export default {
  header: 'We need to verify your phone number',
  remember_device: {
    label: 'Remember this device for {{days}} days',
  },
  buttons: {
    confirm: 'Confirm',
  },
  toasts: {
    invalid_code: 'Invalid code. Please try again.',
  },
};
